var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"steps"},[_c('div',{staticClass:"step-wrap"},_vm._l((_vm.stepList),function(item,index){return _c('step-item',{key:index,attrs:{"stepData":item,"last":index === _vm.stepList.length - 1}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }